import * as tslib_1 from "tslib";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactSelect, { Async, Creatable, AsyncCreatable } from 'react-select';
import cx from 'classnames';
import { noop, merge } from 'lodash';
import toClass from 'recompose/toClass';
import Checkbox from "../../Switchers/Checkbox";
import Radio from "../../Switchers/Radio";
import Tooltip from "../../core/Tooltip";
import { deprecateProps, withFocusedState } from "../../../enhancers";
import "./Select.css";
import Value from './Value';
import Option from './Option'; // TODO: Rename BaseSelect to Select and move Portal usage by default

var BaseSelect =
/** @class */
function (_super) {
  tslib_1.__extends(BaseSelect, _super);

  function BaseSelect(props) {
    var _this = _super.call(this, props) || this;

    _this.setMaxHeight = function () {
      var _a = _this.props,
          maxVisibleRows = _a.maxVisibleRows,
          multi = _a.multi,
          value = _a.value;

      var getOuterHeight = function getOuterHeight(el) {
        var styles = window.getComputedStyle(el);
        return ['borderTopWidth', 'borderBottomWidth', 'marginTop', 'marginBottom', 'paddingTop', 'paddingBottom'].reduce(function (sum, style) {
          return sum + (parseFloat(styles[style]) || 0);
        }, 0);
      };

      if (!_this.state.maxHeight && _this.node && maxVisibleRows && multi && Array.isArray(value) && value.length > 0) {
        var selectValue = _this.node.wrapper.querySelector('.Select-value');

        var selectValueStyles = window.getComputedStyle(selectValue);
        var selectValueHeight = Math.ceil(selectValue.offsetHeight + (parseFloat(selectValueStyles.marginTop) || 0) + (parseFloat(selectValueStyles.marginBottom) || 0));

        var selectMultiWrapper = _this.node.wrapper.querySelector('.Select-multi-value-wrapper');

        var selectMultiWrapperHeight = getOuterHeight(selectMultiWrapper);
        var selectControlHeight = getOuterHeight(_this.node.control);

        _this.setState({
          maxHeight: maxVisibleRows * selectValueHeight + selectMultiWrapperHeight + selectControlHeight
        });
      }
    };

    _this.handleChange = function (value) {
      var _a = _this.props,
          multi = _a.multi,
          onChange = _a.onChange; // Fixes the problem with returning an empty array instead of undefined after remove by backspace

      var isEmptiedSingleSelect = !multi && Array.isArray(value) && value.length === 0;
      onChange(isEmptiedSingleSelect ? undefined : value);
    };

    _this.isOptionChecked = function (option) {
      var _a = _this.props,
          valueKey = _a.valueKey,
          multi = _a.multi,
          value = _a.value; // if no option is checked - prevents controlled/uncontrolled warning

      if (!value) return false;
      return multi && Array.isArray(value) ? value && value.some(function (item) {
        return item[valueKey] === option[valueKey];
      }) : value && value[valueKey] === option[valueKey];
    };

    _this.renderCheckControl = function (checked) {
      var CheckControl = _this.props.multi ? Checkbox : Radio;
      return React.createElement(CheckControl, {
        checked: checked,
        size: 20
      });
    };

    _this.renderOption = function (option) {
      var _a = _this.props,
          hasCheckableControls = _a.hasCheckableControls,
          labelKey = _a.labelKey,
          onOptionMouseEnter = _a.onOptionMouseEnter,
          onOptionMouseLeave = _a.onOptionMouseLeave;
      return React.createElement("div", {
        className: "Select-option-label",
        onTouchStart: function onTouchStart(e) {
          return e.nativeEvent.stopImmediatePropagation();
        },
        onMouseEnter: onOptionMouseEnter,
        onMouseLeave: onOptionMouseLeave
      }, hasCheckableControls && _this.renderCheckControl(_this.isOptionChecked(option)), option[labelKey]);
    }; // converts to a class component, so it can be given a ref for react-select.


    _this.renderOptionComponent = toClass(function (_a) {
      var option = _a.option,
          other = tslib_1.__rest(_a, ["option"]);

      var _b = _this.props,
          tooltipOptions = _b.tooltipOptions,
          blockName = _b.blockName;
      var component = React.createElement(Option, tslib_1.__assign({}, other, {
        option: option
      }));
      var popoverClassName = cx(blockName, tooltipOptions.popoverClassName);
      var mergedTooltipOptions = merge({
        popper: {
          modifiers: {
            preventOverflow: {
              escapeWithReference: true
            }
          }
        }
      }, tooltipOptions);
      return option.description ? React.createElement(Tooltip, tslib_1.__assign({}, mergedTooltipOptions, {
        popoverClassName: popoverClassName,
        text: option.description
      }), component) : component;
    });

    _this.renderArrow = function () {
      var _a;

      var _b = _this.props,
          disabled = _b.disabled,
          blockName = _b.blockName;
      var baseArrowClassName = blockName + "__arrow";
      var arrowClassName = cx(baseArrowClassName, (_a = {}, _a[baseArrowClassName + "--disabled"] = disabled, _a));
      return React.createElement("span", {
        className: arrowClassName
      }, React.createElement("i", {
        className: "icon-custom-caret-down"
      }));
    };

    _this.renderNoResults = function () {
      var _a = _this.props,
          noResultsText = _a.noResultsText,
          noResultsRenderer = _a.noResultsRenderer;

      if (noResultsRenderer) {
        return noResultsRenderer(noResultsText);
      }

      return React.createElement("div", {
        className: "Select-noresults-text"
      }, noResultsText);
    };

    _this.handleOpen = function () {
      var onOpen = _this.props.onOpen;

      _this.setState({
        isOpen: true
      });

      onOpen();
    };

    _this.handleClose = function () {
      var onClose = _this.props.onClose;

      _this.setState({
        isOpen: false
      });

      onClose();
    };

    _this.ref = function (node) {
      var instanceRef = _this.props.instanceRef;
      if (typeof instanceRef === 'function') instanceRef(node);
      _this.node = node;
    };

    _this.shouldResetScroll = false;
    _this.node = null;
    _this.state = {
      isOpen: false
    };
    return _this;
  }

  BaseSelect.prototype.componentDidMount = function () {
    this.setMaxHeight();
  };

  BaseSelect.prototype.componentDidUpdate = function () {
    this.setMaxHeight();

    if (this.shouldResetScroll) {
      this.shouldResetScroll = false;
      this.node.control.scrollTop = 0;
    }
  };

  BaseSelect.prototype.render = function () {
    var _a, _b, _c;

    var _d = this.props,
        tip = _d.tip,
        tipClassName = _d.tipClassName,
        kind = _d.kind,
        className = _d.className,
        isError = _d.isError,
        disabled = _d.disabled,
        focused = _d.focused,
        multi = _d.multi,
        clearable = _d.clearable,
        backspaceRemoves = _d.backspaceRemoves,
        async = _d.async,
        creatable = _d.creatable,
        searchable = _d.searchable,
        renderArrow = _d.renderArrow,
        optionRenderer = _d.optionRenderer,
        hasCheckableControls = _d.hasCheckableControls,
        closeOnSelect = _d.closeOnSelect,
        valueComponent = _d.valueComponent,
        blockName = _d.blockName,
        style = _d.style,
        other = tslib_1.__rest(_d, ["tip", "tipClassName", "kind", "className", "isError", "disabled", "focused", "multi", "clearable", "backspaceRemoves", "async", "creatable", "searchable", "renderArrow", "optionRenderer", "hasCheckableControls", "closeOnSelect", "valueComponent", "blockName", "style"]);

    var containerClassName = cx(blockName, (_a = {}, _a[blockName + "--" + kind] = kind, _a), className);
    var selectStyle = style;

    if (this.state.maxHeight && !focused) {
      selectStyle = merge({
        maxHeight: this.state.maxHeight,
        overflow: 'hidden'
      }, style);
      this.shouldResetScroll = true;
    }

    var componentClassName = cx((_b = {}, _b[blockName + "--disabled"] = disabled, _b[blockName + "--error"] = isError, _b[blockName + "--active"] = focused, _b[blockName + "--disabled-error"] = disabled && isError, _b[blockName + "--active-error"] = focused && isError, _b));
    var finalTipClassName = cx(blockName + "__tip", tipClassName, (_c = {}, _c[blockName + "__tip--hidden"] = this.state.isOpen || disabled && !isError, _c[blockName + "__tip--error"] = isError, _c[blockName + "__tip--active"] = focused, _c));
    var Component = ReactSelect;

    if (async && creatable) {
      Component = AsyncCreatable;
    } else if (async) {
      Component = Async;
    } else if (creatable) {
      Component = Creatable;
    }

    var nxCloseOnSelect = closeOnSelect === undefined ? !multi : closeOnSelect;
    return React.createElement("div", {
      className: containerClassName
    }, React.createElement(Component, tslib_1.__assign({}, other, {
      className: componentClassName,
      onChange: this.handleChange,
      arrowRenderer: renderArrow || this.renderArrow,
      optionRenderer: optionRenderer || this.renderOption,
      noResultsText: this.renderNoResults(),
      valueComponent: valueComponent,
      disabled: disabled,
      searchable: searchable || async || creatable,
      clearable: clearable,
      backspaceRemoves: backspaceRemoves,
      multi: multi,
      ref: this.ref,
      onOpen: this.handleOpen,
      onClose: this.handleClose,
      removeSelected: !hasCheckableControls,
      closeOnSelect: nxCloseOnSelect,
      style: selectStyle,
      optionComponent: this.renderOptionComponent
    })), !!tip && React.createElement("span", {
      className: finalTipClassName
    }, tip));
  };

  BaseSelect.propTypes = {
    /** Available options: `default` (h=32px) and `narrow` (h=24px). */
    kind: PropTypes.string,
    value: PropTypes.any,
    valueKey: PropTypes.string,
    labelKey: PropTypes.string,
    isError: PropTypes.bool,
    focused: PropTypes.bool,
    disabled: PropTypes.bool,
    clearable: PropTypes.bool,
    backspaceRemoves: PropTypes.bool,
    closeOnSelect: PropTypes.bool,
    blockName: PropTypes.string,
    className: PropTypes.string,
    tip: PropTypes.string,
    tipClassName: PropTypes.string,
    noResultsText: PropTypes.string,
    noResultsRenderer: PropTypes.func,
    hasCheckableControls: PropTypes.bool,
    multi: PropTypes.bool,
    // @DEPRECATED: deprecated prop, instead use AsyncSelect
    async: PropTypes.bool,
    creatable: PropTypes.bool,

    /** Search is disabled by default, but adding `async` or `creatable` prop turns it on. */
    searchable: PropTypes.bool,
    renderArrow: PropTypes.func,
    optionRenderer: PropTypes.func,

    /** Ref function to get inner component instance. */
    instanceRef: PropTypes.func,
    activeArrowColor: PropTypes.string,
    disabledArrowColor: PropTypes.string,
    onChange: PropTypes.func,
    onOptionMouseEnter: PropTypes.func,
    onOptionMouseLeave: PropTypes.func,
    onOpen: PropTypes.func,
    onClose: PropTypes.func,
    valueComponent: PropTypes.func,
    maxVisibleRows: PropTypes.number,
    style: PropTypes.object,
    tooltipOptions: PropTypes.object
  };
  BaseSelect.defaultProps = {
    blockName: 'nx-select',
    kind: 'default',
    isError: false,
    focused: false,
    disabled: false,
    labelKey: 'label',
    valueKey: 'value',
    noResultsText: 'No results found',
    searchable: false,
    clearable: false,
    backspaceRemoves: true,
    creatable: false,
    hasCheckableControls: false,
    multi: false,
    onChange: noop,
    instanceRef: noop,
    onOpen: noop,
    onClose: noop,
    valueComponent: Value,
    tooltipOptions: {}
  };
  return BaseSelect;
}(Component);

export default deprecateProps(['async'])(withFocusedState(BaseSelect));

try {
  // @ts-ignore
  BaseSelect.__docgenInfo = {
    "description": "",
    "displayName": "BaseSelect",
    "props": {}
  };
} catch (__react_docgen_typescript_loader_error) {}